<div class="h-100 w-100">

  <div class="row no-gutters justify-content-center q-police">
    {{'Assigncyclestothelearner_EL'|trad}}
  </div>
  <div class="row no-gutters justify-content-center q-police">
    <div *ngIf="user">
      <strong>{{user.FirstName}} {{user.Name}}</strong>
    </div>
  </div>
  <div class="row no-gutters justify-content-center q-police">

    <div class="col-auto q-c-main">{{'DigitalLearningExpirationDate'|trad}} :</div>

    <div class="q-date" style=" width: 150px;">
      <q-date name="dateExpiration" [ngValue]="dateExpiration" (ngValueChange)="dateExpiration = $event"></q-date>
    </div>

    <button class="col-auto q-btn q-main ml-3 p-1"
            (click)="SaveDateExpiration()"
            title="Enregistrer la date d'expiration">
      Enregistrer la date d'expiration
      <i class="fas fa-save"></i>
    </button>

    <button class="col-auto q-btn q-danger ml-3 p-1"
            (click)="DeleteDateExpiration()"
            title="Supprimer la date d'expiration" *ngIf="!IsDateExpirationNull()">
      <i class="fas fa-times"></i>
    </button>

  </div>

  <hr />

  <div class="row no-gutters justify-content-center">
    <strong class="q-c-main">{{'ListOfDigitalLearningAssigned'|trad}}</strong>
  </div>
  <div class="row no-gutters">
    <div class="col-12 col-lg-6 row no-gutters ml-1">
      <div>
        <button type="button" class="btn pl-0 q-btn-transparent d-flex" (click)="uncheckAll()" title="{{'Uncheckall_EL'|trad}}">
          <i class="far fa-square q-icon-uncheck  pt-2 pr-1"></i>
          <div>
            <hr class="separation" />
          </div>
          <strong class="q-police pl-2 pt-2 q-text-uncheck">
            {{'RemoveAllCycle'|trad}}
          </strong>
        </button>
      </div>

    </div>
  </div>
  <div class="row no-gutters">
    <div class="col-12 col-lg-5 pl-1 mb-5">
      <div class="q-listcycles">
        <div *ngFor="let cyc of listCycleEL">
          <div class="q-check">
            <input type="checkbox" name="checkboxCycle" id="{{cyc.Ident}}" [(ngModel)]="cyc.IsChecked" (ngModelChange)="getChapters()" />
            <label for="{{cyc.Ident}}">
              <span></span>{{cyc.Name}}
            </label>
          </div>

        </div>
      </div>
      <br />
      <div class="row no-gutters">
        <button type="button" class="btn btn-save q-main" (click)="addCycleELToUser()" title="Affecter les cycles sélectionnés à l'apprenant"><i class="far fa-save"></i><span> {{'Save_EL'|trad}}</span></button>
      </div>
    </div>
    <div class="col-12 col-lg-7 mb-5">
      <div *ngIf="chapterLoading">
        <i class="fas fa-pulse fa-spin fa-spinner q-c-main"></i> {{'LoadingChapters'|trad}}...
      </div>
      <div *ngIf="!chapterLoading">
        <div *ngIf="listChaptersEL && listChaptersAutOK && listChaptersAutAvailable">
          <div *ngIf="listChaptersEL.length == 0 && listChaptersAutOK.length == 0 && listChaptersAutAvailable.length == 0">
            <div class="noData q-c-light-main">
              <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
              {{'NoCycleSelected'|trad}}
            </div>
          </div>

          <!--Liste des chapitres EL-->
          <div *ngIf="listChaptersEL.length > 0">
            <div class="q-bloc-chapter">
              <div class="row pr-0 q-pointer m-0 q-text-l" (click)="expendList($event, 'EL')">
                <div class="d-flex col-6 align-items-center my-1">
                  <strong class="q-c-main">{{'ELearningChapters'|trad}}</strong>
                </div>
                <div class="d-flex col-4 align-items-center my-2 q-bold rounded-button q-light-black">
                  {{listChaptersEL.length}} {{listChaptersEL.length > 1 ? 'chapitres' : 'chapitre'}}
                </div>
                <div class="d-flex col-1 align-items-center my-1">
                </div>
                <i class="fas fa-chevron-down chevron ml-auto m-2"></i>
              </div>
              <div class="list-closed d-none" #chapELContainer>
                <div *ngFor="let chap of listChaptersEL">
                  <div class="row no-gutters justify-content-between mx-1 py-1 q-chap">
                    <div class="col-8">{{chap.Title}}</div>
                    <div class="col-4 text-right p-0">
                      <!-- GESTION DES DATES -->
                        <div class="align-middle">
                          <q-bo-property-inline class="mr-3" button-custom-class="{{getClassDate(chap.ExpirationDate.Value)}}" type="DATE" (close)="UpdateDate($event,chap)" [property]="chap.ExpirationDate"></q-bo-property-inline>
                        </div>
                   
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
    

          

          <!--Liste des chapitres auteur achetés-->
          <div *ngIf="listChaptersAutOK.length > 0 && stripeIsActive">
            <div class="q-bloc-chapter">
              <div class="row pr-0 q-pointer m-0 q-text-l" (click)="expendList($event, 'AUTOK')">
                <div class="d-flex col-6 align-items-center my-1">
                  <strong class="q-c-main">{{'AuthorChapters'|trad}}</strong>
                </div>
                <div class="d-flex col-4 align-items-center my-2 q-bold rounded-button q-light-black">
                  {{listChaptersAutOK.length}} {{listChaptersAutOK.length > 1 ? 'chapitres' : 'chapitre'}}
                </div>
                <div class="d-flex col-1 align-items-center my-1">
                </div>
                <i class="fas fa-chevron-down chevron ml-auto m-2"></i>
              </div>
              <div class="list-closed d-none" #chapAutOkContainer>
                <div *ngFor="let chap of listChaptersAutOK">
                  <div class="row no-gutters justify-content-between mx-1 py-1 q-chap">
                    <div class="col-6">{{chap.Title}}</div>
                    <div class="col-6 d-flex justify-content-end p-0">
                      <div class="rounded-button ml-1 q-pointer q-date-autor" (click)="PushChapAut(chap)">
                        <span class="ml-3 q-bold q-label-autor"> <i class="far fa-clock mr-1"></i> {{chap.ExpirationDate.Label}}</span>
                        <span class="ml-3 q-bold q-label-autor-hover"> {{'RenewTheChapter'|trad}} <i class="fas fa-cart-plus" *ngIf="!showLoaderPushAut"></i><i class="fas fa-pulse fa-spin fa-spinner" *ngIf="showLoaderPushAut"></i></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
          


          <!--Liste des chapitres auteur disponibles (non achetés)-->
          <div *ngIf="listChaptersAutAvailable.length > 0 && stripeIsActive" class="q-bloc-chapter">
            <div class="row pr-0 q-pointer m-0 q-text-l" (click)="expendList($event, 'AUTAVAILABLE')">
              <div class="d-flex col-6 align-items-center my-1">
                <strong class="q-c-main">{{'NewAuthorChapters'|trad}}</strong>
              </div>
              <div class="d-flex col-4 align-items-center my-2 q-bold rounded-button q-light-black">
                {{listChaptersAutAvailable.length}} {{listChaptersAutAvailable.length > 1 ? 'chapitres' : 'chapitre'}}
              </div>
              <div class="d-flex col-1 align-items-center my-1">
              </div>
              <i class="fas fa-chevron-down chevron ml-auto m-2"></i>
            </div>
            <div class="list-closed d-none" #chapAutAvailableContainer>
              <div class="row no-gutters justify-content-between mx-1 py-1 q-chap">
                <div class="col-5">Titre chapitre</div>
                <div class="col-2 p-0">
                  Tarification
                </div>
                <div class="col-1">
                  Nb
                </div>
                <div class="col-2">
                  Expire le
                </div>
                <div class="col-2 text-right">
                  Montant
                </div>
              </div>
              <div *ngFor="let chap of listChaptersAutAvailable">
                <div class="row no-gutters justify-content-between mx-1 py-1 q-chap">
                  <div class="col-5">{{chap.Title}}</div>
                  <div class="col-2 p-0 q-bold">
                    <span *ngIf="chap.Tarification.Type == 0" class="mr-1">{{chap.Tarification.Montant|money}}/{{'month'|trad}}</span>
                    <span *ngIf="chap.Tarification.Type == 1" class="mr-1">{{chap.Tarification.Montant|money}}/{{'year'|trad}}</span>
                  </div>
                  <div class="col-1">
                    <input type="number" min="0" class="q-input-number" [(ngModel)]="chap.Tarification.Quantite" [disabled]="showPayment" />
                  </div>
                  <div class="col-2 q-bold">{{GetDateExpirationChapES(chap)|qDate}}</div>
                  <div class="col-2 q-bold text-right pr-2">{{GetMontantSelected(chap)|money}}</div>
                </div>
              </div>
              <div class="row no-gutters">

                <div class="col-6 p-3">
                  <button class="q-btn q-main" (click)="OpenPayment()" title="{{'ValidateTheCart'|trad}}" *ngIf="!showPayment && GetNbTotalChapES() > 0">
                    {{'AccessToPayment'|trad}}
                    <i class="fas fa-shopping-cart"></i>
                  </button>
                </div>
                <div class="col-6 p-3 q-c-danger q-bold text-right">
                  Total : {{GetMontantTotalChapES()|money}}
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="showPayment && stripeIsActive" id="#payment">
              <q-wallet [mode]="mode" [items]="items" [refreshWallet]="paymentStripeService.endProcess" [price]="GetMontantTotalChapES()"></q-wallet>
              <div class="row justify-content-center mb-1">
                <div>
                  <button class="q-btn q-main" (click)="ValidPayment()" title="Valider le paiement" [disabled]="GetMontantTotalChapES() > paymentStripeService.wallet">
                    Affecter les chapitres <i class="fas fa-save" *ngIf="!showLoaderPayment"></i><i class="fas fa-pulse fa-spin fa-spinner" *ngIf="showLoaderPayment"></i>
                  </button>
                </div>
                <div>
                  <button class="q-btn q-danger" (click)="ClosePayment()" title="Annuler le paiment">
                    Annuler
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
          </div>

        </div>

      </div>
    </div>

  </div>
  

</div>


